export const adaptRatePlanDataAttributes = (ratePlan): { [key: string]: { [key: string]: string } } => {
  const dataAttributes = getRatePlanDataAttributes(ratePlan);
  if (!dataAttributes) {
    return null;
  }

  const reserveButton = {};
  reserveButton[dataAttributes.key] = dataAttributes.value;

  return {
    reserveButton,
  };
};

export const getRatePlanDataAttributes = ratePlan => {
  if (ratePlan?.priceDetails?.[0]?.dataAttributes) {
    return ratePlan.priceDetails[0].dataAttributes;
  }

  return null;
};
